import { render, staticRenderFns } from "./mrc_ess_phoneInput.vue?vue&type=template&id=11ba345f&scoped=true&"
import script from "./mrc_ess_phoneInput.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_phoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba345f",
  null
  
)

export default component.exports